import React from 'react';
import { Input } from '@h2/ui';
import { Field } from '@h2/types';

interface NumberInputProps {
  field: Field;
  value: number;
  onChange: (value: number) => void;
  error?: string;
}

export const NumberInput: React.FC<NumberInputProps> = ({ field, value, onChange, error }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value);
    onChange(isNaN(newValue) ? 0 : newValue);
  };

  return (
    <Input
      id={field.id}
      type="number"
      value={value || ''}
      onChange={handleChange}
      placeholder={field.placeholder}
      className={error ? 'border-red-500' : ''}
    />
  );
};
